import React from 'react';
import { withTranslation } from 'react-i18next';

const Maintenance = (props) => {
    let content = props.t('maintenanceMessageDefault');
    if(props.start && props.end) {
        content = `${props.t('maintenanceMessageStartAndEnd1')} ${props.start} ${props.t('maintenanceMessageStartAndEnd2')} ${props.end}.`
    } else if (props.end) {
        content = `${props.t('maintenanceMessageEndOnly')} ${props.end}.`;
    }

    return (
        <div>
            <h1>{props.t('maintenanceMessageHeader')}</h1>
            <hr />
            <h3>{content}</h3>
        </div>
    )
    
};

export default withTranslation()(Maintenance);
